// Patches navigator.serviceWorker.addEventListener so that any listener registering after an OFFLINE/ONLINE broadcast (eg. useIsOnline's useEffect, which runs after paint) immediately receives the most recent state
// This ensures that editor-wc will receive an OFFLINE message even if it loads after the initial broadcast (and we don't end up showing an incorrect "online" state)
const setupOnlineStateRelay = (swContainer) => {
  let lastOnlineState = null;
  const _addEventListener = swContainer.addEventListener.bind(swContainer);

  _addEventListener("message", ({ data }) => {
    if (data?.type === "OFFLINE" || data?.type === "ONLINE") {
      lastOnlineState = data.type;
    }
  });

  swContainer.addEventListener = function (type, listener, options) {
    _addEventListener(type, listener, options);
    if (type === "message" && lastOnlineState !== null) {
      const event = { data: { type: lastOnlineState } };
      Promise.resolve().then(() =>
        typeof listener === "function"
          ? listener(event)
          : listener.handleEvent(event),
      );
    }
  };
};

export default setupOnlineStateRelay;
